import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import InfoPopup from "./infoPopup"

import "../../styles/index.scss"

import { setMobile } from "../../state/global"

import poster from "../../images/poster.png"
import sizzle_desktop from "../../images/video/sizzle_desktop.mp4"

const Layout = ({ children, dispatch, mobile, logoTheme }) => {
  useEffect(() => {
    _onWindowResize()
    window.addEventListener("resize", _onWindowResize)
  }, [])

  function _onWindowResize() {
    dispatch(setMobile(window.innerWidth <= 768))
  }

  let sizzle = sizzle_desktop
  let bgColor = logoTheme === "black" ? "black" : "green"

  return (
    <div className={`site-container bg-${bgColor}`}>
      <div className="video-container-outer-bg">
        <div className="video-container site-bg">
          <video controls autoPlay={!mobile} muted loop poster={poster}>
            <source src={sizzle} type="video/mp4" />
          </video>
        </div>
      </div>
      <main>
        {children}
        <InfoPopup />
      </main>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default connect(
  state => ({
    mobile: state.global.mobile,
    logoTheme: state.navbar.logoTheme,
  }),
  null
)(Layout)
